import Breadcrumb from '../../components/common/Breadcrumb'
import styled from '@emotion/styled'
import EClaimForm from './EClaimForm'
import { useRouter } from '../../utils/helper'
import { useGetEClaimById } from '../../services/e-claim/e-claim-query'
import EClaimInfo from './EClaimInfo'

import Loading from '../../components/common/Loading'
import { eClaimDetail, enrollment, home } from '../../constant/path'
import { useScreen } from '../../utils/responsive-helper'

const BreadcrumbContainer = styled.div`
  margin-top: 24px;
  margin-bottom: 24px;
`

const EClaimDetail = () => {
  const { query } = useRouter<{ eClaimId: number }>()
  const { isMobile } = useScreen()
  const { data: eClaimItem, isLoading } = useGetEClaimById({ claimId: query.eClaimId })

  return (
    <Loading loading={isLoading}>
      {!isMobile && (
        <BreadcrumbContainer>
          <Breadcrumb
            overide={(paths) => {
              paths[0] = {
                label: 'Home',
                path: home(),
              }
              paths[1] = {
                label: 'ปรับเปลี่ยนสวัสดิการ',
                path: enrollment(),
              }
              paths[2] = {
                label: `${eClaimItem?.claimName}`,
                path: eClaimDetail(),
              }
              return paths
            }}
          />
        </BreadcrumbContainer>
      )}

      <EClaimInfo eClaimItem={eClaimItem} />

      {/*   <EClaimDocument /> */}

      <EClaimForm eClaimItem={eClaimItem} />
    </Loading>
  )
}

export default EClaimDetail
